import '../src/assets/css/font-size-family.css'
import AllRoutes from './Pages/Routes/AllRoutes';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import ToastMessages from './Components/ToastMessages/ToastMessages';

function App() {
  
  return (
    <div className="App">
      <>
        <div id="loader-full" className="loader-full">
          <div className="spinner-border" role="status">
            <span className="sr-only">Loading...</span>
          </div>
        </div>
        <ToastMessages />
      </>
      <>
        <AllRoutes />
      </>
    </div>
  );
}

export default App;
